export default __webpack_public_path__ + "static/media/shopping.7f2420b6.png";